<ng-container *ngIf="dialog$ | async as dialog">
    <div class="paybee-modal-header flex-column">
      <div class="modal-main-heading">Add to Cart</div>
      <div class="modal-sub-heading">Add items to the user's cart.</div>
    </div>
    <div class="modal-body custom-material-form px-0 angular-custom-material-form updated-dropdown"  [formGroup]="form">
        <div class="step-1">
            <div class="row justify-content-center">
                <div class="col-5 pr-0">
                    <mdb-form-control class="form-fill">
                        <input
                            mdbInput
                            formControlName="email"
                            [mdbAutocomplete]="autocompleteEmail"
                            (keydown.enter)="passOption($event)"
                            maxlength="128"
                            type="text"
                            class="form-control form-control--paybee"
                        />
                        <label mdbLabel class="form-label form-label--paybee">Donor Email</label>
                        @if (form.controls.email.invalid && form.controls.email.touched) {
                            <span class="form-fill-error">Invalid Donor Email</span>
                        }
                    </mdb-form-control>
                    <mdb-autocomplete #autocompleteEmail="mdbAutocomplete">
                        @for(option of searchResult; track option.data.id) {
                            <mdb-option [value]="option.searchString" (click)="passOption(option.searchString)">
                                {{ option.searchString }}
                            </mdb-option>
                        }
                    </mdb-autocomplete>
                </div>
                <div class="col-6">
                    <mdb-form-control class="form-fill">
                        <input
                            mdbInput
                            formControlName="name"
                            [mdbAutocomplete]="autocompleteName"
                            (keydown.enter)="passOption($event)"
                            maxlength="128"
                            type="text"
                            class="form-control form-control--paybee"
                        />
                        <label mdbLabel class="form-label form-label--paybee">Donor Name</label>
                        @if (form.controls.name.invalid && form.controls.name.touched) {
                            <span class="form-fill-error">Invalid Donor Name</span>
                        }
                    </mdb-form-control>
                    <mdb-autocomplete #autocompleteName="mdbAutocomplete">
                        @for(option of searchResult; track option.data.id) {
                            <mdb-option [value]="option.searchString" (click)="passOption(option.searchString)">
                                {{ option.searchString }}
                            </mdb-option>
                        }
                    </mdb-autocomplete>
                </div>
            </div>
            @if(!initialStateCampaignPresent){
                <div class="row justify-content-center mt-1">
                    <div class="col-11">
                        <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                        <div id="selectCampaignListWrapper"></div>
                        <small class="red-text">{{getCampaignErrorMessage()}}</small>
                    </div>
                </div>
            }
          
          <div class="row justify-content-center mt-3" [ngClass]="{'d-none':!campaignSelected}">
              <div class="col-11">
                  <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign Option</div>
                  <div id="selectCampaignOptionListWrapper"></div>
                  <small class="red-text">{{getCampaignOptionErrorMessage()}}</small>
              </div>
          </div>
          <div class="row justify-content-center mt-3" *ngIf="amount$ | async">
              <div class="col-11">
                  <div class="md-form">
                      <input
                          id="add-pending-amount"
                          currency
                          autocomplete="chrome-off"
                          formControlName="amount" 
                          required
                          min="1"
                          step="0.01"
                          type="text"
                          pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
                          inputmode="decimal"
                          data-type="currency"
                          class="form-control"
                      >
                      <label class="inputLabel active" data-error="Invalid Amount" data-success="">
                          Amount
                      </label>
                  </div>
              </div>
          </div>
          <div class="row justify-content-center mt-3" *ngIf="quantity$ | async">
              <div class="col-11">
                  <div class="md-form no-bottom-margin">
                      <input autocomplete="chrome-off" formControlName="quantity" required min="1" step="1" type="number" class="form-control">
                      <label class="inputLabel active" data-success="">
                          Quantity
                      </label>
                      <small class="red-text">{{getQuantityErrorMessage()}}</small>
                  </div>
              </div>
          </div>
          <div class="row justify-content-center mt-3">
            <mdb-accordion [borderless]="true" class="col-11 accordion--additional-information"  [ngClass]="{'d-none': !showAdditionalInformation}">
                <mdb-accordion-item>
                    <ng-template mdbAccordionItemHeader>
                        <div data-toggle="tooltip" data-placement="right" title="This information is required on the donor side, but you can skip this step.">
                            Additional information (Optional)
                        </div>
                    </ng-template>
                    <ng-template mdbAccordionItemBody>
                        <div  class="row justify-content-center mb-3" [ngClass]="{'d-none': !isAddressRequired}">
                            <div class="col-6" >
                                <mdb-form-control class="form-fill mb-0 appGoogleMapsAutocomplete d-flex form-fill--background">
                                    <app-mdb-input-google-maps-autocomplete
                                      id="google-maps-autocomplete"
                                      mdbInput
                                      autocomplete="address"
                                      label="Address"
                                      formControlName="address"
                                      class="d-flex w-100"
                                    ></app-mdb-input-google-maps-autocomplete>
                                </mdb-form-control>
                            </div>
                            <div class="col-6">
                                <mdb-form-control class="form-fill mb-0 form-fill--background" >
                                    <app-mdbp-input mdbInput formControlName="unitNum" label='Unit/Apt#'></app-mdbp-input>
                                </mdb-form-control>
                            </div>
                        </div>
                    <div class="row justify-content-center mb-3"  [ngClass]="{'d-none': !isPhoneRequired}">
                        <div class="col-12">
                            <mdb-form-control class="form-fill mb-0 form-fill--background" >
                                <app-mdbp-input mdbInput formControlName="phone" autocomplete="tel" type='tel' [showMaxLength]="false" phoneInputMask="on" label='Phone Number'></app-mdbp-input>
                            </mdb-form-control>
                        </div>
                    </div>
        
                    <div class="row justify-content-center mb-3" [ngClass]="{'d-none': !additionalInfoRequired}">
                        <div class="col-12">
                            <!-- <div [innerHTML]="additionalInfoHeader" class="text-left" style="color: #757575; font-size: 0.8rem;"></div> -->
                            <mdb-form-control class="form-fill mb-0 form-fill--background" >
                                <app-mdbp-input mdbInput maxLength="512" formControlName="additionalInfo"  [label]='detail'></app-mdbp-input>
                            </mdb-form-control>
                        </div>
                    </div>
        
                    <div class="row justify-content-center mb-3" [ngClass]="{'d-none':!isAdditionalInfoSelectListShow}">
                        <div class="col-12">
                            <div class="text-left" style="color: #757575; font-size: 0.8rem;">{{
                                additionalInfoSelectListHeader
                            }}</div>
                            <div id="selectAdditionalInfoSelectListWrapper"></div>
                        </div>
                    </div>
                    </ng-template>
                </mdb-accordion-item>
            </mdb-accordion>
          </div>
          <div class="row justify-content-center mt-3" [ngClass]="{'d-none':!isOptionSelected}">
              <div class="col-11">
                  <div class="text-left" style="color: #757575; font-size: 0.8rem;">Tag To Event (Optional)</div>
                  <div id="selectEventTypeListWrapper">
       
                  </div>
              </div>
          </div>
          <div class="row justify-content-center mt-3" [ngClass]="{'d-none':!isEventTypeSelected}">
              <div class="col-11">
                  <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Event</div>
                  <div id="selectEventListWrapper"></div>
              </div>
          </div>
        </div>
        <div class="step-2 p-3" id="merchandiseBlock">
        </div>
    </div>
    <div class="modal-footer modal-footer--import">
      <div class="row">
        <!-- @if(isMerchandiseCamp && !isShowForm){ -->
            <div [ngStyle]="{'display': (isMerchandiseCamp || isPartySignupCamp) && step === 1 && isShowForm ? 'flex' : 'none'}">
                <div class="col-2 offset-4" >
                    <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" style="min-width: 120px;" (click)="close(dialog, false)">Cancel</button>
                  </div>
                <div class="col-2">
                    <button type="button" class="btn btn--paybee btn--confirm  btn--md text-center w-100" style="min-width: 120px;" (click)="onClickGoToForm()">Next</button>
                </div>
            </div>

            <div [ngStyle]="{'display': (isMerchandiseCamp || isPartySignupCamp) && step === 1 && !isShowForm ? 'flex' : 'none'}">
                <div class="col-2 offset-4" >
                    <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" style="min-width: 120px;" (click)="close(dialog, false)">Cancel</button>
                  </div>
                <div class="col-2">
                    <button type="button" class="btn btn--paybee btn--confirm  btn--md text-center w-100" style="min-width: 120px;" (click)="onConfirm(dialog, true)">Add to Cart</button>
                </div>
            </div>

        <!-- }@else if(isMerchandiseCamp  && isShowForm){ -->
            <div  [ngStyle]="{'display': (isMerchandiseCamp || isPartySignupCamp) && step === 2 ? 'flex' : 'none'}">
                <div class="col-2 offset-4">
                    <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" style="min-width: 120px;" (click)="onBackClick()">Back</button>
                  </div>
                <div class="col-2">
                    <button type="button" class="btn btn--paybee btn--confirm  btn--md text-center w-100" style="min-width: 120px;" (click)="onConfirm(dialog, true)">Add to Cart</button>
                </div>
            </div>

        <!-- }@else{ -->
            <div [ngStyle]="{'display': (!isMerchandiseCamp && !isPartySignupCamp) ? 'flex' : 'none'}">
                <div class="col-2 offset-4" >
                    <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" style="min-width: 120px;" (click)="close(dialog, false)">Cancel</button>
                  </div>
                <div class="col-2">
                    <button type="button" class="btn btn--paybee btn--confirm  btn--md text-center w-100" style="min-width: 120px;" (click)="onConfirm(dialog, true)">Add to Cart</button>
                </div>
            </div>

        <!-- } -->
      </div>
    </div>  
  </ng-container>
